<template>
  <div class="">
    <ui-modal ref="modal4" title="Variações do produto">
      <div class="w-full p-2">
        <h2 class="mb-2">Variações cadastradas</h2>
        <div class="my-5">
          <div>
            <form
              action=""
              @submit.prevent="
                modal_variation_action === 'created'
                  ? storeVariation()
                  : updateVariation()
              "
              class="flex"
            >
              <input
                type="text"
                v-model="name"
                required
                class="transition rounded-r-none duration-200 ease-in transform text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:shadow-focus focus:border-indigo-400 focus:outline-none py-4 pr-4 pl-4"
              />
              <button
                class="rounded-l-none transition duration-300 ease-in-out focus:outline-none text-white text-xs py-2 px-3 rounded focus:shadow-focus bg-indigo-600"
              >
                <font-awesome-icon icon="plus" class="" />
                {{
                  modal_variation_action === 'created'
                    ? 'Adicionar'
                    : 'Atualizar'
                }}
              </button>
            </form>
          </div>
          <small>Exemplo: Cor,Tamanho e etc.</small>
        </div>
      </div>
    </ui-modal>

    <button
      @click="openModal('modal4')"
      type="button"
      class="transition duration-300 ease-in-out focus:outline-none text-white text-xs py-2 px-3 rounded focus:shadow-focus bg-indigo-600"
    >
      <font-awesome-icon icon="plus" class="mr-2" />
      Variações do produto
    </button>
    <div class="w-full">
      <div>
        <div class="" v-for="(variation, index) in variations" :key="index">
          <div
            class="rounded-lg p-4 my-2 relative bg-gray-200 hover:bg-gray-300"
            v-if="!variation.deleted_at"
          >
            <div class="flex items-center">
              <ui-switch v-model="variations[index].enabled">
                <span class="font-display font-bold">{{ variation.name }}</span>
                <small> - {{ variation.options.length }} Opções</small>
              </ui-switch>
            </div>

            <div class="pr-2 pt-2 ">
              <div class="mt-2 flex flex-wrap">
                <button
                  type="button"
                  class="mr-2 py-2 px-4 text-xs bg-indigo-500 text-white rounded flex-none"
                  @click="modalOptionAndSelectIndex(index)"
                >
                  <font-awesome-icon icon="plus" size="xs" />
                  Gerenciar opções
                </button>
                <button
                  @click="editVariation(index)"
                  type="button"
                  class="font-medium focus:outline-none mt-1 md:mt-0 mr-2 px-2 py-1 bg-indigo-200 text-indigo-600 hover:text-indigo-800 text-lg rounded-lg text-center border-2 border-transparent focus:border-indigo-600"
                >
                  <font-awesome-icon icon="pen" size="xs" />
                </button>
                <button
                  @click="removeVariation(index)"
                  type="button"
                  class="bg-red-200 font-medium mt-1 md:mt-0 focus:outline-none px-2 py-1 text-red-600 hover:text-red-700 text-lg rounded-lg text-center border-2 border-transparent focus:border-red-600"
                >
                  <font-awesome-icon icon="trash-alt" size="xs" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ui-modal ref="modal5" title="Adicionar opção">
        <ui-modal
          ref="modalEditOption"
          title="Variações do produto"
          @close="option_name = ''"
        >
          <div class="w-full p-2">
            <h2 class="mb-2">Editar Opção</h2>
            <div class="my-5">
              <div>
                <form
                  action=""
                  @submit.prevent="updateVariationOption"
                  class="flex"
                >
                  <input
                    type="text"
                    v-model="option_name"
                    required
                    class="transition rounded-r-none duration-200 ease-in transform text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:shadow-focus focus:border-indigo-400 focus:outline-none py-4 pr-4 pl-4"
                  />
                  <button
                    class="rounded-l-none transition duration-300 ease-in-out focus:outline-none text-white text-xs py-2 px-3 rounded focus:shadow-focus bg-indigo-600"
                  >
                    <font-awesome-icon icon="plus" class="" />
                    Atualizar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </ui-modal>
        <div class="w-full p-2">
          <form
            action=""
            @submit.prevent="storeOptionToVariation()"
            class="flex "
          >
            <input
              type="text"
              required
              v-model="option_name"
              class="transition rounded-r-none duration-200 ease-in transform text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:shadow-focus focus:border-indigo-400 focus:outline-none py-4 pr-4 pl-4"
            />
            <button
              class="rounded-l-none transition duration-300 ease-in-out focus:outline-none text-white text-xs py-2 px-3 rounded focus:shadow-focus bg-indigo-600"
            >
              <font-awesome-icon icon="plus" class="" />
              Adicionar
            </button>
          </form>
          <small
            >Opção são valores relacionado a variação exemplo: se a variação for
            de cor, você adiciona o nome da cor</small
          >
          <div class="w-full" v-if="variations[variation_index]">
            <div
              v-for="(option, index) in variations[variation_index].options"
              :key="`option-${index}`"
            >
              <div
                class="mt-2 border rounded py-4 px-4 font-bold relative bg-gray-200 hover:bg-gray-300"
                v-if="!variations[variation_index].options[index].deleted_at"
              >
                <ui-switch
                  v-model="variations[variation_index].options[index].enabled"
                >
                  <span class="font-display font-bold">{{ option.value }}</span>
                </ui-switch>

                <div class="py-2 px-3 absolute top-0 right-0">
                  <button
                    @click="editVariationOption(index)"
                    type="button"
                    class="font-medium bg-indigo-200 mr-1 focus:outline-none px-2 py-1 text-indigo-600 hover:text-indigo-700 text-lg rounded-lg text-center border-2 border-transparent focus:border-indigo-600"
                  >
                    <font-awesome-icon icon="pen" size="xs" />
                  </button>
                  <button
                    @click="removeVariationOption(index)"
                    type="button"
                    class="font-medium bg-red-200 focus:outline-none px-2 py-1 text-red-600 hover:text-red-700 text-lg rounded-lg text-center border-2 border-transparent focus:border-red-600"
                  >
                    <font-awesome-icon icon="trash-alt" size="xs" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ui-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    limit_variations: {
      type: Number,
      default: 1
    },
    limit_options: {
      type: Number,
      default: 3
    },
    variations: {
      type: Array,
      default: function() {
        return []
      }
    },
    variation_type_id: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      name: '',
      modal_variation_action: 'created',
      modal_option_action: 'created',
      variation_index: '',
      variation_updated_index: '',
      option_updated_index: '',
      option_name: ''
    }
  },
  computed: {
    getVariationEnabled() {
      return this.variations.filter(value => {
        return !value.enabled
      })
    }
  },
  methods: {
    openModal(ref) {
      this.$refs[ref].open()
    },
    closeModal(ref) {
      this.$refs[ref].close()
    },
    editVariation(index) {
      this.variation_updated_index = index
      this.modal_variation_action = 'updated'
      this.name = this.variations[index].name
      this.openModal('modal4')
    },
    removeVariation(index) {
      console.log(index)
      const variation = this.variations[index]

      if (variation.id) {
        this.variations[index].deleted_at = true
        this.storeEvent()
      } else {
        this.$emit('input', this.variations)
        this.variations.splice(index, 1)
      }
    },
    editVariationOption(index) {
      this.option_name = this.variations[this.variation_index].options[
        index
      ].value
      this.option_updated_index = index
      this.openModal('modalEditOption')
    },
    removeVariationOption(index) {
      if (this.variations[this.variation_index].options[index].id) {
        this.variations[this.variation_index].options[index].deleted_at = true
      } else {
        this.variations[this.variation_index].options.splice(index, 1)
      }
      this.$emit('input', this.variations)
    },
    modalOptionAndSelectIndex(index) {
      this.variation_index = index
      this.openModal('modal5')
    },
    storeEvent() {
      this.$emit('input', this.variations)
    },
    storeVariation() {
      this.variations.push({
        id: null,
        name: this.name,
        variation_type_id: this.variation_type_id,
        enabled: true,
        options: [],
        deleted_at: false
      })
      this.closeModal('modal4')
      this.name = ''
      this.storeEvent()
    },
    updateVariation() {
      this.variations[this.variation_updated_index].name = this.name
      this.closeModal('modal4')
      this.name = ''
      this.storeEvent()
    },
    storeOptionToVariation() {
      this.variations[this.variation_index].options.push({
        id: null,
        enabled: true,
        value: this.option_name,
        deleted_at: false
      })
      this.option_name = ''
      this.storeEvent()
    },
    updateVariationOption() {
      this.variations[this.variation_index].options[
        this.option_updated_index
      ].value = this.option_name
      this.option_name = ''
      this.option_updated_index = ''
      this.closeModal('modalEditOption')
      this.storeEvent()
    }
  }
}
</script>
